module.exports = __webpack_public_path__ + "img/check.9953a6d2.svg";